import Header from "../../components/Header/Header";
import FormLocCasa from "../../components/FormLocCasa/FormLocCasa";
import Footer from "../../components/Footer/Footer";

export default function CadastroLocCasa() {
  return (
    <>
        <Header />
        <FormLocCasa />
        <Footer />
    </>
  );
}